module.exports = "https://coinrabbit.io/_next/static/images/privacy_text-icon-08b12204539d7f9ed1c0958b5065481e.png";